import React from 'react';
import { FormattedMessage } from 'react-intl';

export const renderNameGreeting = (greetingStr, nameStr) => {
  if (!nameStr) { return null; }
  const loweredName = nameStr.toLowerCase();
  const formattedName = loweredName.charAt(0).toUpperCase() + loweredName.slice(1);
  return (<div data-testid="greeting"><b>{greetingStr}, {formattedName}</b></div>);
};

export const determineGreetingByTimeOfDay = (date) => {
  const hours = date.getHours();
  if (hours < 12) {
    return (
      <FormattedMessage
        id="enroll.greeting.morning"
        defaultMessage="Good morning"
      />
    );
  } if (hours < 17) {
    return (
      <FormattedMessage
        id="enroll.greeting.afternoon"
        defaultMessage="Good afternoon"
      />
    );
  }
  return (
    <FormattedMessage
      id="enroll.greeting.evening"
      defaultMessage="Good evening"
    />
  );
};

export const createTrackingObj = (step, steps) => {
  const journey = 'track_journey_step';
  return {
    label: journey,
    element: journey,
    identifier: step,
    meta: {
      step: {
        id: step,
        path: step,
        meta: null,
        name: null,
      },
      steps,
    },
  };
};
